import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';

const SLIDES = [
  {
    img:     '/images/Somayya-Academy-Slider-Images-1806-by-958-white.jpeg',
    label:   'Online Lectures Available',
    text:    'During COVID-19 pandemic, we stand with the students and parents. We respect the social distancing rules and decided to offer the courses online! Stay Home, Stay Safe!',
    btnText: 'Start a Course',
    btnLink: '/all-courses',
  },
  {
    img:     '/images/Somayya-Academy-Slider-Images-1806-by-958-white_002.jpeg',
    label:   '21 Years of Excellence',
    text:    'Celebrating 21 years of excellence, in teaching and guiding students. Established in 1999, Somayya Academy is the most sought-after brand amongst coaching classes in Pune.',
    btnText: 'Know More',
    btnLink: '/about-us',
  },
  {
    img:     '/images/Somayya-Academy-Slider-Images-1806-by-958-white.jpeg',
    label:   '50,000+ Successful Students',
    text:    'More than 50,000 students have experienced the quality and depth of our teaching. Today, the alumnae of Somayya Academy are spreading knowledge and wisdom, all over.',
    btnText: 'Contact Us',
    btnLink: '/contact-us',
  },
  {
    img:     '/images/Somayya-Academy-Slider-Images-1806-by-958-white_002.jpeg',
    label:   'Study Abroad Consultancy',
    text:    'One solution for all trainings! Entrance examinations, language trainings, consultancy services, career guidance!',
    btnText: 'Know More',
    btnLink: '/study-abroad',
  },
  {
    img:     '/images/Somayya-Academy-Slider-Images-1806-by-958-white_002.jpeg',
    label:   'Lingual Services',
    text:    'One solution for all trainings! Entrance examinations, language trainings, consultancy services, career guidance!',
    btnText: 'Know More',
    btnLink: '/lingual-services',
  },
];

export default function HeroSlider() {
  return (
    <section className="sa-hero">
      <Swiper
        modules={[Autoplay, Navigation]}
        autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
        navigation
        loop
        speed={800}
      >
        {SLIDES.map((slide, i) => (
          <SwiperSlide key={i}>
            {/* Background image */}
            <img src={slide.img} alt={slide.label} />

            {/* Dark overlay + centred content — matches .overlay-default + .slider-content */}
            <div className="sa-hero-overlay">
              <div className="sa-hero-text">
                {/* Big uppercase label — matches .title1 from original (font-size 56px) */}
                <span className="sa-slide-label">{slide.label}</span>

                {/* Paragraph sub-text */}
                <h3>{slide.text}</h3>

                {/* CTA button — matches .default-big-btn */}
                <div className="sa-slider-btn">
                  <Link to={slide.btnLink} className="sa-btn sa-btn-primary">
                    {slide.btnText}
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
